// extracted by mini-css-extract-plugin
module.exports = {"dashboardCard":"Dashboard_dashboardCard__Tqs8w"};